// Sustemia · Balance Hídrico · navegación por modo
// Un solo lugar con la lista de pasos de cada modo (con su número y su
// bajada, igual que pasos() en Sustemia_BalanceHidrico_Modulo_ES_v1.html),
// para que la barra lateral combinada (BalanceSidebar) y cada workspace
// hablen del mismo dato sin duplicarlo.

export const NAV_CERO = [
  { grpKey: "water_balance_group_setup" },
  { key: "tipologia", n: "01", labelKey: "water_balance_step_typology", capKey: "water_balance_cap_tipologia" },
  { key: "instrumentos", n: "02", labelKey: "water_balance_step_instruments", capKey: "water_balance_cap_instrumentos" },
  { key: "centros", n: "03", labelKey: "water_balance_step_centers", capKey: "water_balance_cap_centros" },
  { grpKey: "water_balance_group_period" },
  { key: "contexto", n: "04", labelKey: "water_balance_step_context", capKey: "water_balance_cap_contexto" },
  { key: "entradas", n: "05", labelKey: "water_balance_step_inherited_entries", capKey: "water_balance_cap_entradas" },
  { key: "fichas", n: "06", labelKey: "water_balance_step_field_cases", capKey: "water_balance_cap_fichas" },
  { key: "salidas", n: "07", labelKey: "water_balance_step_outputs", capKey: "water_balance_cap_salidas" },
  { key: "costos", n: "08", labelKey: "water_balance_step_costing", capKey: "water_balance_cap_costos" },
  { key: "cierre", n: "09", labelKey: "water_balance_step_closing", capKey: "water_balance_cap_cierre" },
  { key: "informe", n: "10", labelKey: "water_balance_step_report", capKey: "water_balance_cap_informe" },
];

export const NAV_DATOS = [
  { key: "cargar", n: "01", labelKey: "water_balance_datos_step_cargar", capKey: "water_balance_cap_datos_cargar" },
  { key: "balance", n: "02", labelKey: "water_balance_datos_step_balance", capKey: "water_balance_cap_datos_balance" },
  { key: "informe", n: "03", labelKey: "water_balance_datos_step_informe", capKey: "water_balance_cap_informe" },
];

export const NAV_DIA0 = [
  { key: "quetenes", n: "01", labelKey: "water_balance_dia0_step_quetenes", capKey: "water_balance_cap_dia0_quetenes" },
  { key: "balance", n: "02", labelKey: "water_balance_dia0_step_balance", capKey: "water_balance_cap_dia0_balance" },
  { key: "medidor", n: "03", labelKey: "water_balance_dia0_step_medidor", capKey: "water_balance_cap_dia0_medidor" },
  { key: "informe", n: "04", labelKey: "water_balance_dia0_step_informe", capKey: "water_balance_cap_dia0_informe" },
];

export const PRIMER_PASO_POR_MODO = { cero: "tipologia", demo: "tipologia", datos: "cargar", dia0: "quetenes" };

export function navDeModo(modo) {
  if (modo === "datos") return NAV_DATOS;
  if (modo === "dia0") return NAV_DIA0;
  return NAV_CERO; // 'cero' y 'demo' comparten el mismo wizard
}

export default { NAV_CERO, NAV_DATOS, NAV_DIA0, PRIMER_PASO_POR_MODO, navDeModo };
